import React from 'react';
import {translate} from '../Services/translation'

const SubNavCompact = ({subNavigation}) => (
    <nav className="subnav subnav--compact" role="navigation">
        {displayReturnLink(subNavigation)}
        {displaySubNav(subNavigation)}
    </nav>
)

/**
 *
 * @param {Object} subNav
 * @returns {JSX.Element}
 */
const displayReturnLink = (subNav) => {
    const {parent} = subNav;

    if (parent === null) {
        return null;
    }

    return (
        <a className="subnav__return" href={parent.url}>
            <svg aria-hidden="true" className="icon" focusable="false">
                <use xlinkHref="#arrow-left"></use>
            </svg>
            <span>{translate('navigation.backto')} {parent.name}</span>
        </a>
    );
}

/**
 * Mobile subnav
 *
 * If there is an activeItem in the "subnav.links" argument and that item has submenu items, we show those instead.
 * In mobile, we only want to show the current menu level IF there is no submenu items in the active menu item.
 *
 * @param subnav
 * @returns {JSX.Element}
 */
const displaySubNav = subnav => {
    let activeItem = subnav.links.filter(x => x.isSelected)[0];

    return (
        <ul className="subnav__list">
            {typeof activeItem !== 'undefined' && activeItem.links.length ? (
                <>
                    {activeItem.links && activeItem.links.map((item, index) =>
                        <li className={`subnav__item`} key={`subnavCompact-${index}`}>
                            <a className="subnav__link" href={item.url}>{item.name}</a>
                        </li>
                    )}
                </>
            ) : (
                <>
                    {subnav.links && subnav.links.map((item, index) =>
                        <li className={`subnav__item
                            ${item.links && item.links.length > 0 ? 'has-children' : ''}
                            ${item.isSelected ? 'active' : ''}`} key={`subnavCompact-${index}`}>
                            <a className="subnav__link" href={item.url}>{item.name}</a>
                        </li>
                    )}
                </>
            )}
        </ul>
    );
}

export default SubNavCompact;